<template>
    <div class="contact-us-block">
        <ul>
            <!-- <li>
                <el-popover
                        placement="left"
                        width="100"
                        trigger="hover">
                    <div class="call-us">
                        <p class="font-size-16">联系电话</p>
                        <p class="color-067EF2 font-size-16">15210288780</p>
                        <p class="font-size-16">工作时间</p>
                        <p class="color-067EF2 font-size-16">9：00 - 18：30</p>
                    </div>
                    <el-card slot="reference" :body-style="{ padding: '10px',width:'48px',height:'48px',display: 'flex',alignItems: 'center'}">
                        <img src="../assets/images/icon-tele.png">
                    </el-card>
                </el-popover>
            </li> -->
            <li>
                <el-popover
                        placement="left"
                        width="150"
                        trigger="hover">
                    <div style="text-align: center">
                        <img style="margin: auto;width:142px;height:142px" src="@/assets/images/iedu/qrcode_1.jpg">
                        <p>扫一扫</p>
                        <p>联系我们</p>
                    </div>
                    <el-card slot="reference" :body-style="{ padding: '10px',width:'48px',height:'48px',display: 'flex',alignItems: 'center'}">
                        <img src="../assets/images/icon-weChat.png">
                    </el-card>
                </el-popover>
            </li>
            <el-backtop>
                <li>
                    <a>
                        <el-card slot="reference" :body-style="{ padding: '10px',width:'48px',height:'48px',display: 'flex',alignItems: 'center'}">
                            <img src="../assets/images/icon-goTop.png">
                        </el-card>
                    </a>
                    <!--<el-backtop target=".mod" :bottom="100">

                    </el-backtop>-->
                </li>
            </el-backtop>
        </ul>
    </div>
</template>

<script>
    import imgPath from "@/common/img-path";
    export default {
        name: "contactUsFixed",
        data () {
            return {
                imgPath: imgPath,
            }
        }
    }
</script>

<style scoped>
.contact-us-block{
    position: fixed;
    right: 26px;
    bottom: 100px;
    z-index: 1;
}
.contact-us-block ul li{
    margin-top: 20px;
}
.contact-us-block img{
    margin: auto;
}
.color-067EF2{color: #FFDB6A}
.font-size-16{font-size: 16px}
    .call-us p{margin: 5px 0px}
</style>
